import {JsonProperty} from '@hyperloris/tyson';

export class SimpleRequest {
  @JsonProperty()
  value: string;

  constructor(value_: string) {
    this.value = value_;
  }
}


